import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.6884 4.5068h2.2776c.2426 0 .4448-.2022.4582-.4448V2.4582A.4544.4544 0 0 0 14.966 2h-2.965a.4545.4545 0 0 0-.4582.4582v2.5203c.1348-.0135.283-.0135.4178-.0135h.0404q.3436 0 .6874.0404z",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.1602 10.7199c-.1078-2.9785-2.4663-5.4044-5.4717-5.7144a5.2 5.2 0 0 0-.647-.0404h-.0404c-.1482 0-.31 0-.4582.0135-3.1132.2156-5.593 2.6954-5.7009 5.7413h-.3234a.696.696 0 0 0-.7008.7008c0 .3774.2965.6873.6873.7008h13.0055c.3774 0 .7008-.31.7008-.7008s-.3234-.7008-.7008-.7008zm1.3747 2.3179H4.4674c-.3774 0-.6874.2964-.6874.6873 0 .3773.31.6738.6874.6738h.6873c.3774 0 .6873.31.6873.6874v3.6119c0 .566.4583 1.0242 1.0243 1.0242s1.0243-.4582 1.0243-1.0242v-3.6119c0-.3774.31-.6874.6873-.6874s.6874.31.6874.6874v3.6119c0 .566.4582 1.0242 1.0242 1.0242a1.024 1.024 0 0 0 1.0243-1.0242v-3.6119c0-.3774.31-.6874.6873-.6874s.6874.31.6874.6874v3.6119c0 .566.4582 1.0242 1.0242 1.0242a1.024 1.024 0 0 0 1.0243-1.0242v-3.6119c0-.3774.31-.6874.6873-.6874s.6874.31.6874.6874v3.6119c0 .566.4582 1.0242 1.0242 1.0242a1.024 1.024 0 0 0 1.0243-1.0242v-3.6119c0-.3774.31-.6874.6873-.6874h.6874c.3773 0 .6873-.2965.6873-.6738 0-.3909-.31-.6873-.6873-.6873m0 7.601H4.4674c-.3774 0-.6874.2965-.6874.6739 0 .3773.31.6873.6874.6873h15.0675c.3773 0 .6873-.31.6873-.6873s-.31-.6739-.6873-.6739",
        clipRule: "evenodd"
    }, "1")
], "VerticalPolitical", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
